import { getAllJournal } from '@/api/mouvementClient/index';
import genererCritereRechercheJournalPaiements from '@/services/journalPaiements/genererCritereRechercheJournalPaiements';
import { MODULE_BAIL } from '@/configuration/devisConf';
import * as types from './journalPaiements-mutation-type';
import { RESET_STATE } from '../mutation-type';

export function initialState(moduleDcf = MODULE_BAIL) {
  return {
    items: [],
    total: 0,
    critereRechercheJournalPaiements: genererCritereRechercheJournalPaiements(moduleDcf),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total;
  },
  [types.SET_CRITERE_JOURNAL_PAIEMENTS](state, critereRechercheJournalPaiements) {
    state.critereRechercheJournalPaiements = critereRechercheJournalPaiements;
  },
  [types.RESET_CRITERE](state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadJournalPaiements({ commit }, paramFilter) {
    commit(types.SET_LAST_PAYLOAD, paramFilter);
    const response = (await getAllJournal(paramFilter)).data.result;
    commit(types.SET_TOTAL, response.totalCount);
    commit(types.SET_ITEMS, response.items);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  critereRechercheJournalPaiements: state => {
    return state.critereRechercheJournalPaiements;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
